/* Palsora "?" info pop-ups: hover or keyboard focus shows them (CSS); tap toggles them on touch screens; kept inside the screen */
(function () {
  if (window.__palsTip) return;
  window.__palsTip = true;
  function placeTip(tip) {
    var box = tip.querySelector('.pals-tip__box');
    if (!box) return;
    box.style.setProperty('--tip-x', '0px');
    var r = box.getBoundingClientRect(), pad = 12, shift = 0;
    if (r.left < pad) shift = pad - r.left;
    else if (r.right > window.innerWidth - pad) shift = window.innerWidth - pad - r.right;
    box.style.setProperty('--tip-x', Math.round(shift) + 'px');
  }
  function closeTips(except) {
    document.querySelectorAll('[data-pals-tip].is-open').forEach(function (t) {
      if (t === except) return;
      t.classList.remove('is-open');
      var b = t.querySelector('.pals-tip__btn'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pals-tip__btn');
    if (!btn) { closeTips(null); return; }
    e.preventDefault();
    var tip = btn.closest('[data-pals-tip]');
    var open = !tip.classList.contains('is-open');
    closeTips(tip);
    tip.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) placeTip(tip);
  });
  document.addEventListener('mouseover', function (e) {
    var tip = e.target.closest && e.target.closest('[data-pals-tip]');
    if (tip) placeTip(tip);
  });
  document.addEventListener('focusin', function (e) {
    var tip = e.target.closest && e.target.closest('[data-pals-tip]');
    if (tip) placeTip(tip);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTips(null); });
})();
